import { ConfigFn } from '@config/types'

const config = (({ searchUrl }) =>
  ({
    urlHashParam: 'bid',
    utmContent: 'blick-bites',
    blickBitesApiUrl: `${searchUrl}/bites`,
    localStorageHideOnboardingOverlayKey: 'blickBitesHideOnboardingOverlay',
  }) as const) satisfies ConfigFn

export default config
